<div class="smartquote-totals d-none d-sm-block">
    <div class="d-flex align-items-center">
        <div>
            @if (quote(); as quote) {
                @if (!quote.accepted && !quote.declined) {
                    <button sfButton size="md" color="success" icon="clipboard-check" (click)="onAccept.emit()">
                        Accept
                    </button>
                    <button sfButton size="md" color="danger" icon="xmark-circle" (click)="onDecline.emit()">
                        Decline
                    </button>
                }

                @if (quote?.accepted) {
                    <span class="text-success fw-bold fs-3 mb-0 text-uppercase">Quote Accepted</span>
                }

                @if (quote.declined) {
                    <span class="text-danger fw-bold fs-3 mb-0 text-uppercase">Quote Declined</span>
                }
            }
        </div>
        <div class="ms-auto">
            <p class="mb-0 text-end fw-bold fs-4">
                Total <span class="small">(inc VAT)</span>:
                <span class="fw-bold text-success">{{ total() | currency }}</span>
            </p>
        </div>
    </div>
</div>
